export function ayinGunleri(yil, ay) {
  const ilkGun = new Date(yil, ay, 1);
  const sonGun = new Date(yil, ay + 1, 0);
  const gunler = [];
  for (let g = 1; g <= sonGun.getDate(); g++) {
    gunler.push(new Date(yil, ay, g));
  }
  return gunler;
}

export function gunKey(date) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

export const getSon3AyKeys = () => {
  const keys = [];
  const d = new Date();
  for (let i = 0; i < 3; i++) {
    const m = d.getMonth() - i;
    const y = d.getFullYear();
    const date = new Date(y, m, 1);
    const key = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;
    keys.push({ 
      key, 
      etiket: `${AY_ADLARI[date.getMonth()]} ${date.getFullYear()}` 
    });
  }
  return keys;
};

export function ayKey(yil, ay) {
  return `${yil}-${String(ay + 1).padStart(2, '0')}`;
}

export const AY_ADLARI = [
  'Ocak','Şubat','Mart','Nisan','Mayıs','Haziran',
  'Temmuz','Ağustos','Eylül','Ekim','Kasım','Aralık'
];

export const GUN_ADLARI = ['Pzt','Sal','Çar','Per','Cum','Cmt','Paz'];

export function paraCevir(sayi) {
  if (!sayi && sayi !== 0) return '—';
  return new Intl.NumberFormat('tr-TR', {
    style: 'currency', currency: 'TRY', maximumFractionDigits: 0
  }).format(sayi);
}
